module.exports = __webpack_public_path__ + "img/bpGreen.f39fac91.png";